import { render } from "./LagosBranch.vue?vue&type=template&id=4537ff00&scoped=true"
import script from "./LagosBranch.vue?vue&type=script&lang=js"
export * from "./LagosBranch.vue?vue&type=script&lang=js"

import "./LagosBranch.vue?vue&type=style&index=0&id=4537ff00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4537ff00"]])

export default __exports__